module.exports = __webpack_public_path__ + "static/media/Group 25122.687cf30e.svg";